import * as React from "react";
import styled from "styled-components";

export type IconProps = {
    graphic: string;
    data?: {};
};

export type IconState = {
    graphic: string;
    data?: {};
};

const Styled = {
    SVGContainer: styled.svg`
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    color: white;
    height: 24px;
    width: 24px;
    margin: 0;
    margin-top: 2px;
    padding: 0;
    overflow: hidden;
    text-align: center;
  `,
    BotOutline: styled.path`
    color: rgba(0, 0, 0, 0.87);
    fill-rule: evenodd;
    fill: black;
  `,
    BotEyesOn: styled.path`
    color: rgba(0, 0, 0, 0.87);
    fill-rule: evenodd;
    fill: rgb(0, 177, 169);
  `,
    BotEyesOff: styled.path`
    color: rgba(0, 0, 0, 0.87);
    fill-rule: evenodd;
    fill: rgb(114, 114, 114);
  `
}

export class Icon extends React.Component<IconProps, IconState> {
    static defaultProps: IconProps = {
        graphic: "ARROW",
        data: {},
    };
    
    state = {
        graphic: this.props.graphic,
        data: this.props.data,
    };
    
    render() {
        const {
            state: { graphic, data },
        } = this;
        
        return this.generatePath(graphic, data);
    }
    
    generatePath(type: string, data: {} = {}) {
        if (type === "BOT") {
            return (
                <Styled.SVGContainer
                    key={this.props.graphic + `_ICON`}
                    viewBox={`0 0 24 24`}
                    version={`1.1`}
                    className={`bot`}
                    style={{
                        width: "48px",
                        height: "48px",
                    }}
                >
                    <Styled.BotOutline
                        d={`M12 .75a.69.69 0 01.692.689v1.378h1.385a.69.69 0 01.692.689.69.69 0 01-.692.689h-1.385v1.378a.69.69 0 01-.692.689.69.69 0 01-.693-.689V4.195H9.923a.69.69 0 01-.692-.689c0-.38.31-.689.692-.689h1.384V1.439c0-.38.31-.689.693-.689zm4.154 6.89H7.846C5.17 7.64 3 9.8 3 12.463c0 2.664 2.17 4.823 4.846 4.823h8.308c2.676 0 4.846-2.16 4.846-4.823 0-2.664-2.17-4.823-4.846-4.823zm-11.77 4.823a3.453 3.453 0 013.462-3.445h8.308a3.453 3.453 0 013.461 3.445 3.453 3.453 0 01-3.461 3.445H7.846a3.453 3.453 0 01-3.462-3.445zm4.155 6.89h6.923a.69.69 0 01.692.689.69.69 0 01-.692.689H8.539a.69.69 0 01-.693-.69c0-.38.31-.688.693-.688zm4.154 2.756h-1.385a.69.69 0 00-.692.689c0 .38.31.689.692.689h1.385a.69.69 0 00.692-.69.69.69 0 00-.692-.688z`}
                    />
                    {(data["awaitingInput"] || true) ?
                        <Styled.BotEyesOn
                            d={`M7.847 13.733c.765 0 1.385-.617 1.385-1.378 0-.761-.62-1.378-1.385-1.378s-1.384.617-1.384 1.378c0 .76.62 1.378 1.384 1.378zM12 13.733c.765 0 1.385-.617 1.385-1.378 0-.761-.62-1.378-1.384-1.378-.765 0-1.385.617-1.385 1.378 0 .76.62 1.378 1.385 1.378zM16.155 13.733c.765 0 1.385-.617 1.385-1.378 0-.761-.62-1.378-1.385-1.378s-1.385.617-1.385 1.378c0 .76.62 1.378 1.385 1.378z`}
                        /> :
                        <Styled.BotEyesOff
                            d={`M7.847 13.733c.765 0 1.385-.617 1.385-1.378 0-.761-.62-1.378-1.385-1.378s-1.384.617-1.384 1.378c0 .76.62 1.378 1.384 1.378zM12 13.733c.765 0 1.385-.617 1.385-1.378 0-.761-.62-1.378-1.384-1.378-.765 0-1.385.617-1.385 1.378 0 .76.62 1.378 1.385 1.378zM16.155 13.733c.765 0 1.385-.617 1.385-1.378 0-.761-.62-1.378-1.385-1.378s-1.385.617-1.385 1.378c0 .76.62 1.378 1.385 1.378z`}
                        />
                    }
                </Styled.SVGContainer>
            );
        } else if (type === "ARROW") {
            return (
                <Styled.SVGContainer
                    key={this.props.graphic + `_ICON`}
                    viewBox={`0 0 24 24`}
                    version={`1.1`}
                >
                    <path
                        fillRule={`evenodd`}
                        fill={`white`}
                        d={`M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z`}
                    />
                </Styled.SVGContainer>
            );
        } else if (type === "BACK-ARROW") {
            return (
                <Styled.SVGContainer
                    viewBox={`0 0 24 24`}
                    fill={`none`}
                    style={{
                        marginTop: "13px",
                        marginLeft: "12px",
                    }}
                    xmlns={`http://www.w3.org/2000/svg`}
                >
                    <path
                        d={`M8 2L2.18437 6.84636C2.08842 6.92631 2.08842 7.07369 2.18437 7.15364L8 12`}
                        stroke={`#393C44`}
                        strokeWidth={`2.5`}
                        strokeLinecap={`round`}
                    />
                </Styled.SVGContainer>
            );
        } else if (type === "CLOSE") {
            return (
                <Styled.SVGContainer
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M14.25 4.75L4.75 14.25"
                        stroke="#A6A6B3"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M4.75 4.75L14.25 14.25"
                        stroke="#A6A6B3"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </Styled.SVGContainer>
            );
        } else if (type === "DROP-DOWN") {
            return (
                <Styled.SVGContainer
                    width="12"
                    height="7"
                    viewBox="0 0 12 7"
                    fill="none"
                    style={{
                        display: "inline-block",
                        verticalAlign: "middle",
                        marginTop: "15px",
                        float: "right",
                        width: "15px",
                        height: "15px",
                        marginRight: "15px",
                        marginBottom: "25px",
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M11 1L6.14142 5.85858C6.06332 5.93668 5.93668 5.93668 5.85858 5.85858L1 1"
                        stroke="#B3B6C9"
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                </Styled.SVGContainer>
            );
        } else if (type === "CHECK-ON") {
            return (
                <Styled.SVGContainer
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    style={{
                        display: "inline-block",
                        verticalAlign: "middle",
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="21" height="21" rx="5" fill="#217CE8"/>
                    <path
                        d="M15.6654 7.5L9.2487 13.9167L6.33203 11"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </Styled.SVGContainer>
            );
        } else if (type === "CHECK-OFF") {
            return (
                <Styled.SVGContainer
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    style={{
                        display: "inline-block",
                        verticalAlign: "middle",
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        x="0.5"
                        y="0.5"
                        width="20"
                        height="20"
                        rx="4.5"
                        stroke="#E8E8EF"
                    />
                </Styled.SVGContainer>
            );
        } else if (type === "NEW") {
            return (
                <Styled.SVGContainer
                    key={this.props.graphic + `_ICON`}
                    viewBox={`0 0 512 512`}
                    version={`1.1`}
                >
                    <path
                        d={`M256,0C114.833,0,0,114.833,0,256s114.833,256,256,256s256-114.853,256-256S397.167,0,256,0z M256,472.341c-119.275,0-216.341-97.046-216.341-216.341S136.725,39.659,256,39.659S472.341,136.705,472.341,256S375.295,472.341,256,472.341z`}
                    />
                    <path
                        d={`M355.148,234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83,8.884-19.83,19.83v79.318h-79.318c-10.966,0-19.83,8.884-19.83,19.83s8.864,19.83,19.83,19.83h79.318v79.318c0,10.946,8.864,19.83,19.83,19.83s19.83-8.884,19.83-19.83v-79.318h79.318c10.966,0,19.83-8.884,19.83-19.83S366.114,234.386,355.148,234.386z`}
                    />
                </Styled.SVGContainer>
            );
        } else if (type === "ADD") {
            return (
                <Styled.SVGContainer
                    key={this.props.graphic + `_ICON`}
                    viewBox={`0 0 24 24`}
                    version={`1.1`}
                >
                    <path
                        fill={`#4691f6`}
                        stroke={`#4691f6`}
                        strokeWidth="1"
                        d={`M14.613,10c0,0.23-0.188,0.419-0.419,0.419H10.42v3.774c0,0.23-0.189,0.42-0.42,0.42s-0.419-0.189-0.419-0.42v-3.774H5.806c-0.23,0-0.419-0.189-0.419-0.419s0.189-0.419,0.419-0.419h3.775V5.806c0-0.23,0.189-0.419,0.419-0.419s0.42,0.189,0.42,0.419v3.775h3.774C14.425,9.581,14.613,9.77,14.613,10 M17.969,10c0,4.401-3.567,7.969-7.969,7.969c-4.402,0-7.969-3.567-7.969-7.969c0-4.402,3.567-7.969,7.969-7.969C14.401,2.031,17.969,5.598,17.969,10 M17.13,10c0-3.932-3.198-7.13-7.13-7.13S2.87,6.068,2.87,10c0,3.933,3.198,7.13,7.13,7.13S17.13,13.933,17.13,10`}
                    />
                </Styled.SVGContainer>
            );
        } else if (type === "CLOSE_LEFT") {
            return (
                <Styled.SVGContainer
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    style={{
                        display: "inline-block",
                        verticalAlign: "middle",
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M11 17L6 12L11 7"
                        stroke="#B3B6C9"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M18 17L13 12L18 7"
                        stroke="#B3B6C9"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </Styled.SVGContainer>
            );
        } else if (type === "SEARCH") {
            return (
                <Styled.SVGContainer
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    style={{
                        display: "inline-block",
                        verticalAlign: "middle",
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
                        stroke="#A5A5B8"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M14.0016 13.9996L11.1016 11.0996"
                        stroke="#A5A5B8"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </Styled.SVGContainer>
            );
        } else if (type === "DATABASE") {
            return (
                <Styled.SVGContainer
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    style={{
                        display: "inline-block",
                        verticalAlign: "middle",
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0)">
                        <path
                            d="M11 7.33301C15.5563 7.33301 19.25 6.10179 19.25 4.58301C19.25 3.06422 15.5563 1.83301 11 1.83301C6.44365 1.83301 2.75 3.06422 2.75 4.58301C2.75 6.10179 6.44365 7.33301 11 7.33301Z"
                            fill="#808292"
                        />
                        <path
                            d="M2.75 4.58301V17.4163C2.75 18.938 6.41667 20.1663 11 20.1663C15.5833 20.1663 19.25 18.938 19.25 17.4163V4.58301"
                            fill="#808292"
                        />
                        <path
                            d="M21.0846 9.16699C21.0846 10.6887 16.6032 11.917 11.0013 11.917C5.39945 11.917 0.917969 10.6887 0.917969 9.16699"
                            stroke="#F1F4FC"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M21.0846 3.66699C21.0846 5.18866 16.6032 6.41699 11.0013 6.41699C5.39945 6.41699 0.917969 5.18866 0.917969 3.66699"
                            stroke="#F1F4FC"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0">
                            <rect width="22" height="22" fill="white"/>
                        </clipPath>
                    </defs>
                </Styled.SVGContainer>
            );
        } else if (type === "GRAB") {
            return (
                <Styled.SVGContainer
                    width="11"
                    height="16"
                    viewBox="0 0 11 16"
                    fill="none"
                    style={{
                        display: "inline-block",
                        verticalAlign: "middle",
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="2.22798" cy="1.45455" r="1.45455" fill="#CED0D7"/>
                    <circle cx="8.77486" cy="1.45455" r="1.45455" fill="#CED0D7"/>
                    <circle cx="2.22798" cy="14.5454" r="1.45455" fill="#CED0D7"/>
                    <circle cx="8.77486" cy="14.5454" r="1.45455" fill="#CED0D7"/>
                    <circle cx="2.22798" cy="8.00044" r="1.45455" fill="#CED0D7"/>
                    <circle cx="8.77486" cy="8.00044" r="1.45455" fill="#CED0D7"/>
                </Styled.SVGContainer>
            );
        } else {
            throw Error("Invalid Icon type: " + type);
        }
    }
}
